import { type FC } from 'react';
import LoginForm from '@/components/auth/LoginForm';

export const LoginPage: FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 'var(--spacing-lg)',
      }}
    >
      <LoginForm />
    </div>
  );
};

export default LoginPage;
